
export const MyFeature = () => ({
  myFeature(): string {
    return 'MyFeature';
  },
});
